import request from '@/utils/request'

export function getMessage() {
  return request({
    url: '/user/internal-message/findByCustomerId',
    method: 'get',
  })
}
export function readAll() {
  return request({
    url: '/user/internal-message/readAll',
    method: 'post',
  })
}
export function getDetail(params) {
  return request({
    url: '/user/internal-message/tc/detail',
    method: 'get',
    params,
  })
}

//查询客服初始化配置
export function getKefConfig() {
  return request({
    url: '/setting/customer-service/detail',
    method: 'get',
  })
}
